import { ChevronRight } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/class-control";

interface ButtonMoreProps {
  onClick?: () => void
  classNameIcon?: string
  className?: string
}

export default function ButtonMore(props: ButtonMoreProps) {

  return (
    <Button
      size="sm"
      variant="outline"
      className={cn("border-gray-600 text-gray-300 hover:bg-gray-700 h-[50px]", props.className)}
      onClick={props.onClick}
    >
      <p className="text-xs text-[#F6F6F6]">Ver mais</p>
      <ChevronRight className="size-4 text-[#F6F6F6]" />
    </Button>
  )
} 